import { render, staticRenderFns } from "./WCodeGeneration.vue?vue&type=template&id=caf2ca36&scoped=true&"
import script from "./WCodeGeneration.vue?vue&type=script&lang=js&"
export * from "./WCodeGeneration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf2ca36",
  null
  
)

export default component.exports